import { ControlCard } from "./models/index.js";
import t from "../common/event-logger.js";
import s from "../models/request-result.js";
import { logger as r, EventTypes as i } from "../../shared-lib/index.js";
import { STORAGE_KEYS as o } from "../managers/storage-manager.js";
export default class a {
  constructor(t) {
    (this.u = t), (this.u = t);
  }
  h(n, e) {
    const l = new s();
    if ((n.p(), null == n.url || "" === n.url))
      return (
        r.info(`Card ${n.id} has no url. Not logging click to Braze servers.`),
        l
      );
    if (e && n.id && this.u) {
      const t = this.u.j(o.C.v) || {};
      (t[n.id] = !0), this.u.I(o.C.v, t);
    }
    const a = this.$([n]);
    if (null == a) return l;
    const u = e ? i.k : i.D;
    return t.q(u, a);
  }
  B(n) {
    const e = new s();
    if (!n.N())
      return (
        r.info(
          `Card ${n.id} refused this dismissal. Ignoring analytics event.`,
        ),
        e
      );
    if (n.id && this.u) {
      const t = this.u.j(o.C.A) || {};
      (t[n.id] = !0), this.u.I(o.C.A, t);
    }
    const l = this.$([n]);
    return null == l ? e : t.q(i.F, l);
  }
  G(n, e) {
    const l = new s(!0),
      a = [],
      u = [];
    let c = {};
    this.u && (c = e ? this.u.j(o.C.H) || {} : this.u.j(o.C.J) || {});
    for (const t of n) {
      t.K()
        ? (t instanceof ControlCard ? u.push(t) : a.push(t),
          t.id && (c[t.id] = !0))
        : r.info(
            `Card ${t.id} logged an impression too recently. Ignoring analytics event.`,
          );
    }
    const h = this.$(a),
      m = this.$(u);
    if (null == h && null == m) return (l.L = !1), l;
    if ((this.u && (e ? this.u.I(o.C.H, c) : this.u.I(o.C.J, c)), null != h)) {
      const s = e ? i.M : i.O,
        n = t.q(s, h);
      l.P(n);
    }
    if (null != m && e) {
      const s = t.q(i.R, m);
      l.P(s);
    }
    return l;
  }
  $(t) {
    let s,
      n = null;
    for (let r = 0; r < t.length; r++)
      (s = t[r].id),
        null != s &&
          "" !== s &&
          ((n = n || {}), (n.ids = n.ids || []), n.ids.push(s));
    return n;
  }
}
